var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomSection',{staticClass:"head-family"},[(_vm.dataList != null)?[_c('card-profile-patient',{attrs:{"data":_vm.dataList[0]}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }